import { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { Loader2, Bell } from 'lucide-react';
import { useRouter } from 'next/navigation';

import { NotificationItem } from './notification-item.ui';

import { useInfiniteNotifications } from '@/slw/entities/notification/notification.query';
import { useInView } from '@/slw/shared/hooks/use-in-view';
import { useMarkAsRead } from '@/slw/entities/notification/notification.mutation';
import { Notification } from '@/slw/entities/notification/notification.type';

interface Props {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}
export const NotificationsList = ({ setIsOpen }: Props) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const markReadMutation = useMarkAsRead();
  const router = useRouter();

  const { notifications, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } = useInfiniteNotifications();

  const { ref: loadMoreRef, inView } = useInView({
    threshold: 0.5,
  });

  // Load more items when scrolling to the bottom
  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, isFetchingNextPage, fetchNextPage]);

  if (isLoading) {
    return (
      <div className='flex items-center justify-center py-8'>
        <Loader2 className='w-6 h-6 animate-spin text-gray-400' />
      </div>
    );
  }

  const handleMarkReadItem = async (notification: Notification) => {
    await markReadMutation.mutateAsync(notification.id);

    if (notification.link) {
      // window.location.href = `${window.location.origin}/listing/${notification.link}`;
      router.push(`/listing/${notification.link}`);
      setIsOpen(false);
    }
  };

  return (
    <div ref={scrollRef} className='max-h-96 overflow-y-auto border'>
      {notifications.length === 0 ? (
        <div className='p-8 text-center text-gray-500'>
          <Bell className='w-8 h-8 mx-auto mb-2 text-gray-300' />
          <p>No notifications yet</p>
        </div>
      ) : (
        <div className='divide-y-1 divide-[#EBE9E5]'>
          {notifications.map((notification) => (
            <NotificationItem key={notification.id} notification={notification} onMarkReadItem={handleMarkReadItem} />
          ))}
          {/* Load more trigger element */}
          {hasNextPage && <div ref={loadMoreRef} className='h-[1px]' />}
          {isFetchingNextPage && (
            <div className='flex items-center justify-center py-4'>
              <Loader2 className='w-4 h-4 animate-spin text-gray-400' />
              <span className='ml-2 text-sm text-gray-500'>Loading more...</span>
            </div>
          )}
          {/* {!hasNextPage && notifications.length > 0 && (
            <div className='text-center py-4 text-sm text-gray-500'>No more notifications</div>
          )} */}
        </div>
      )}
    </div>
  );
};
